import setSiteMeta from '../base-saving-actions/set-site-meta';

const updateCustomColors = (colors) => setSiteMeta(['customization', 'customColors'], colors);

export default updateCustomColors;
